// alert("Yoo! 😎\n\nWe're in preview mode!\nWith our new QA Tool, you can now see alerts like this one.\n\nPretty cool, right?");

function appendingBug() {
  const rootUrl = window.location.pathname.includes("/products/");
  if (!rootUrl) {
    return;
  }

  const sections = document.querySelectorAll(
    '[id^="shopify-section-main-"], [class*="new-product__layout--"]'
  );

  if (!sections.length) {
    return;
  }

  // Iterate through each section
  sections.forEach((section) => {
    const priceElements = section.querySelectorAll(
      ".product__price.price-main"
    );

    if (!priceElements.length) {
      return;
    }

    priceElements.forEach((priceElement) => {
      if (!priceElement.querySelector(".product__offer-bug")) {
        const offerBugSpan = document.createElement("span");
        offerBugSpan.classList.add("product__offer-bug");

        const img = document.createElement("img");
        img.alt = "Offer Bug";

        const pathname = window.location.pathname;

        // // Bundle paths — these take highest priority
        // const bundlePaths = [
        //   "/products/player-gps-speaker-bundle-v2",
        //   "/products/ringer-gps-handheld-bundle-v2",
        //   "/products/series-4-ultra-bundle-v2",
        //   "/products/speaker-bundle",
        //   "/products/gps-offer",
        //   "/products/laser-offer"
        // ];

        // const isBundle = bundlePaths.some(path => pathname.includes(path));
        // const isPlayerPlus = pathname.includes("/products/player-gps-speaker") && !isBundle;

        // if (isBundle) {
        //   img.src = "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/bundles-lable-cw.svg?v=1764570581";
        // } else if (isPlayerPlus) {
        //   img.src = "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/cw-label-pp-pdp.svg?v=1764065996";
        // } else {
        //   img.src = "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/cw-label-pdp.svg?v=1764064075";
        // }
        img.src =
          "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/Frame_1000012263.svg?v=1765180544";

        offerBugSpan.appendChild(img);
        priceElement.appendChild(offerBugSpan);
      }
    });
  });
}
appendingBug();


function ArrowHandler() {
  const arrowHover = document.querySelectorAll(".Hover__arrow");

  arrowHover.forEach((arrow) => {
    arrow.addEventListener("mouseover", () => {
      arrow.classList.add("Arrow_hovering");
    });
    arrow.addEventListener("mouseout", () => {
      arrow.classList.remove("Arrow_hovering");
    });
  });
}
ArrowHandler();

document.addEventListener("DOMContentLoaded", function () {
  function ticker() {
    gsap.registerEffect({
      name: "ticker",
      effect(targets, config) {
        buildTickers({
          targets: targets,
          clone:
            config.clone ||
            ((el) => {
              let clone = el.children[0].cloneNode(true);
              el.insertBefore(clone, el.children[0]);
              return clone;
            }),
        });
        function buildTickers(config, originals) {
          let tickers;
          if (originals && originals.clones) {
            originals.clones.forEach(
              (el) => el && el.parentNode && el.parentNode.removeChild(el)
            );
            originals.forEach((el, i) =>
              originals.inlineWidths[i]
                ? (el.style.width = originals.inlineWidths[i])
                : el.style.removeProperty("width")
            );
            tickers = originals;
          } else {
            tickers = config.targets;
          }
          const clones = (tickers.clones = []),
            inlineWidths = (tickers.inlineWidths = []);
          tickers.forEach((el, index) => {
            inlineWidths[index] = el.style.width;
            el.style.width = "10000px";
            el.children[0].style.display = "inline-block";
            let width = el.children[0].offsetWidth,
              cloneCount = Math.ceil(window.innerWidth / width),
              right = el.dataset.direction === "right",
              i;
            el.style.width = width * (cloneCount + 1) + "px";
            for (i = 0; i < cloneCount; i++) {
              clones.push(config.clone(el));
            }
            gsap.fromTo(
              el,
              {
                x: right ? -width : 0,
              },
              {
                x: right ? 0 : -width,
                duration: width / 100 / parseFloat(el.dataset.speed || 1),
                repeat: -1,
                overwrite: "auto",
                ease: "none",
              }
            );
          });
          originals ||
            window.addEventListener("resize", () =>
              buildTickers(config, tickers)
            );
        }
      },
    });

    gsap.effects.ticker(".hero__ticker-init");
  }
  ticker();

  //----------------------------------
  // Site Header Function
  //--------------------

  function siteMainHeader() {
    const siteHeaders = document.querySelectorAll(".site-header");
    const megaMenuBackface = document.querySelector(".megaMenu_backface");
    const menuToggles = document.querySelectorAll(".menu-toggle");
    const menus = document.querySelectorAll(".menu_custom"); // Changed to querySelectorAll
    const megaMenus = document.querySelectorAll(".site__megaMenu_container");
    const backButtons = document.querySelectorAll(".back-button");

    // Function to detect mobile
    function isMobile() {
      return window.innerWidth < 768; // Adjust breakpoint as needed
    }

    function closeAllMenus(currentItem) {
      document
        .querySelectorAll(".site_headerContains__megaMenu")
        .forEach((item) => {
          if (item !== currentItem) {
            const menu = item.querySelector(".site__megaMenu_container");
            const link = item.querySelector(".item_has--dropdown");
            menu.classList.remove("site_megaMenu__Active");
            link.classList.remove("site_megaMenu__Active");
            gsap.to(menu, { height: 0, duration: 0.3, ease: "power2.out" });

            const columns = menu.querySelectorAll(".site_megaMenu_left-ul");
            columns.forEach((col) => {
              const colItems = col.querySelectorAll("li");
              gsap.to(colItems, {
                opacity: 0,
                y: 20,
                duration: 0.2,
                ease: "power2.out",
              });
            });

            const rightColumns = menu.querySelectorAll(".site__megaMenu_right");
            rightColumns.forEach((col) => {
              const colItems = col.querySelectorAll("li");
              gsap.to(colItems, {
                opacity: 0,
                y: 20,
                duration: 0.2,
                ease: "power2.out",
              });
            });
          }
        });
    }

    function resetMegaMenus() {
      document.querySelectorAll(".site__megaMenu_container").forEach((menu) => {
        menu.classList.remove("active", "site_megaMenu__Active");
        gsap.set(menu, { height: 0 });

        const leftItems = menu.querySelectorAll(".site_megaMenu_left-ul li");
        const rightItems = menu.querySelectorAll(".site__megaMenu_right li");

        gsap.set(leftItems, { opacity: 0, y: 20 });
        gsap.set(rightItems, { opacity: 0, y: 20 });
      });

      document.querySelectorAll(".item_has--dropdown").forEach((link) => {
        link.classList.remove("site_megaMenu__Active");
      });

      toggleMenu(false);
    }

    function toggleMenu(state) {
      siteHeaders.forEach((header) => {
        header.classList.toggle("site-header--megamenu-active", state);
      });

      megaMenuBackface.classList.toggle("megaMenu_backface--active", state);
      toggleBodyScroll(state);
    }

    function toggleBodyScroll(state) {
      const isAnyHeaderActive = Array.from(siteHeaders).some((header) =>
        header.classList.contains("active")
      );
      if (isAnyHeaderActive || state) {
        const scrollBarWidth =
          window.innerWidth - document.documentElement.clientWidth;
        document.body.classList.add("no-scroll");
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = scrollBarWidth + "px";
      } else {
        document.body.classList.remove("no-scroll");
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      }
    }

    function animateToAutoHeight(element) {
      const curHeight = element.offsetHeight;
      element.style.height = "auto";
      const autoHeight = element.offsetHeight;
      element.style.height = curHeight + "px";
      gsap.to(element, {
        height: autoHeight,
        duration: 0.3,
        ease: "power2.out",
      });
    }

    // Desktop mega menu logic
    document
      .querySelectorAll(".site_headerContains__megaMenu")
      .forEach((item) => {
        const megaMenu = item.querySelector(".site__megaMenu_container");
        const navLink = item.querySelector(".item_has--dropdown");
        const isMenuDisabled =
          item.getAttribute("data-disable-menu") === "true";

        const columns = megaMenu.querySelectorAll(".site_megaMenu_left-ul");
        columns.forEach((col) => {
          const colItems = col.querySelectorAll("li");
          gsap.set(colItems, { opacity: 0, y: 20 });
        });

        const rightColumns = megaMenu.querySelectorAll(".site__megaMenu_right");
        rightColumns.forEach((col) => {
          const colItems = col.querySelectorAll("li");
          gsap.set(colItems, { opacity: 0, y: 20 });
        });

        if (isMenuDisabled) {
          megaMenu.classList.add("site_megaMenu__Active");
          navLink.classList.add("site_megaMenu__Active");
          gsap.set(megaMenu, { height: "auto" });
          toggleMenu(true);
        } else if (!isMobile()) {
          item.addEventListener("mouseenter", () => {
            closeAllMenus(item);
            megaMenu.classList.add("site_megaMenu__Active");
            navLink.classList.add("site_megaMenu__Active");
            animateToAutoHeight(megaMenu);
            columns.forEach((col) => {
              const colItems = col.querySelectorAll("li");
              gsap.to(colItems, {
                opacity: 1,
                y: 0,
                duration: 0.2,
                stagger: 0.1,
                ease: "power2.out",
              });
            });
            rightColumns.forEach((col) => {
              const colItems = col.querySelectorAll("li");
              gsap.to(colItems, {
                opacity: 1,
                y: 0,
                duration: 0.2,
                stagger: 0.1,
                ease: "power2.out",
              });
            });
            toggleMenu(true);
          });

          item.addEventListener("mouseleave", () => {
            const hoveredItem = document.querySelector(
              ".site_headerContains__megaMenu:hover"
            );
            if (hoveredItem) {
              const newMegaMenu = hoveredItem.querySelector(
                ".site__megaMenu_container"
              );
              newMegaMenu.style.height = "auto";
              const newHeight = newMegaMenu.offsetHeight;
              gsap.to(megaMenu, {
                height: newHeight,
                duration: 0.3,
                ease: "power2.out",
              });
            } else {
              gsap.to(megaMenu, {
                height: 0,
                duration: 0.3,
                ease: "power2.out",
              });
            }
            columns.forEach((col) => {
              const colItems = col.querySelectorAll("li");
              gsap.to(colItems, {
                opacity: 0,
                y: 20,
                duration: 0.2,
                ease: "power2.out",
              });
            });
            rightColumns.forEach((col) => {
              const colItems = col.querySelectorAll("li");
              gsap.to(colItems, {
                opacity: 0,
                y: 20,
                duration: 0.2,
                ease: "power2.out",
              });
            });
            closeAllMenus();
            toggleMenu(false);
          });

          navLink.addEventListener("mouseenter", () => toggleMenu(true));
          megaMenu.addEventListener("mouseenter", () => toggleMenu(true));
          navLink.addEventListener("mouseleave", () =>
            setTimeout(
              () =>
                toggleMenu(
                  !!document.querySelector(
                    ".item_has--dropdown:hover, .site__megaMenu_container:hover"
                  )
                ),
              800
            )
          );
          megaMenu.addEventListener("mouseleave", () =>
            setTimeout(
              () =>
                toggleMenu(
                  !!document.querySelector(
                    ".item_has--dropdown:hover, .site__megaMenu_container:hover"
                  )
                ),
              300
            )
          );

          navLink.addEventListener("click", (e) => {
            e.preventDefault();
            const currentHeight = megaMenu.offsetHeight;
            if (currentHeight === 0) {
              megaMenu.classList.add("site_megaMenu__Active");
              navLink.classList.add("site_megaMenu__Active");
              animateToAutoHeight(megaMenu);
              columns.forEach((col) => {
                const colItems = col.querySelectorAll("li");
                gsap.to(colItems, {
                  opacity: 1,
                  y: 0,
                  duration: 0.2,
                  stagger: 0.1,
                  ease: "power2.out",
                });
              });
              rightColumns.forEach((col) => {
                const colItems = col.querySelectorAll("li");
                gsap.to(colItems, {
                  opacity: 1,
                  y: 0,
                  duration: 0.2,
                  stagger: 0.1,
                  ease: "power2.out",
                });
              });
              toggleMenu(true);
            } else {
              gsap.to(megaMenu, {
                height: 0,
                duration: 0.3,
                ease: "power2.out",
              });
              columns.forEach((col) => {
                const colItems = col.querySelectorAll("li");
                gsap.to(colItems, {
                  opacity: 0,
                  y: 20,
                  duration: 0.2,
                  ease: "power2.out",
                });
              });
              rightColumns.forEach((col) => {
                const colItems = col.querySelectorAll("li");
                gsap.to(colItems, {
                  opacity: 0,
                  y: 20,
                  duration: 0.2,
                  ease: "power2.out",
                });
              });
              closeAllMenus(item);
              toggleMenu(false);
            }
          });
        }
      });

    // Mobile menu toggle
    menuToggles.forEach((toggle) => {
      toggle.addEventListener("click", function () {
        siteHeaders.forEach((header) => {
          header.classList.toggle("active");
        });
        menus.forEach((menu) => {
          menu.classList.toggle("active"); // Updated to toggle all menus
        });
        toggleBodyScroll(true);

        if (
          !Array.from(siteHeaders).some((header) =>
            header.classList.contains("active")
          )
        ) {
          resetMegaMenus();
        }
      });
    });

    // Mobile mega menu click behavior
    if (isMobile()) {
      megaMenus.forEach((megaMenu) => {
        const parentLi = megaMenu.closest("li");
        const navLink = parentLi.querySelector(".nav_link");

        navLink.addEventListener("click", function (e) {
          e.preventDefault();
          megaMenu.classList.add("active");
          const columns = megaMenu.querySelectorAll(".site_megaMenu_left-ul");
          columns.forEach((col) => {
            const colItems = col.querySelectorAll("li");
            gsap.to(colItems, {
              opacity: 1,
              y: 0,
              duration: 0.2,
              stagger: 0.1,
              ease: "power2.out",
            });
          });
          const rightColumns = megaMenu.querySelectorAll(
            ".site__megaMenu_right"
          );
          rightColumns.forEach((col) => {
            const colItems = col.querySelectorAll("li");
            gsap.to(colItems, {
              opacity: 1,
              y: 0,
              duration: 0.2,
              stagger: 0.1,
              ease: "power2.out",
            });
          });
        });
      });
    }

    // Back buttons on mobile
    if (isMobile()) {
      backButtons.forEach((backButton) => {
        backButton.addEventListener("click", function () {
          const megaMenu = this.closest(".site__megaMenu_container");
          megaMenu.classList.remove("active");
          const columns = megaMenu.querySelectorAll(".site_megaMenu_left-ul");
          columns.forEach((col) => {
            const colItems = col.querySelectorAll("li");
            gsap.set(colItems, { opacity: 0, y: 20 });
          });
          const rightColumns = megaMenu.querySelectorAll(
            ".site__megaMenu_right"
          );
          rightColumns.forEach((col) => {
            const colItems = col.querySelectorAll("li");
            gsap.set(colItems, { opacity: 0, y: 20 });
          });
        });
      });
    }
  }
  
  siteMainHeader();

  //-----------------------------
  // SLIDER SCRIPT START BANNERS
  //-----------------------


  function sliderLogic() {
    const images = document.querySelectorAll(
      ".am-main_slider-img .am-slide_item"
    );
    const texts = document.querySelectorAll(".am-main_slider-text");
    const progressBars = document.querySelectorAll(
      ".progress_bar-slider .blue"
    );
    let currentSlide = 0;
    let slideInterval;
    let isTransitioning = false;

    // Assign unique IDs to slides
    function assignSlideIDs() {
      const allSlides = document.querySelectorAll(
        ".am-main_slider-img .am-slide_item"
      );
      let highestId = 0;

      allSlides.forEach((img) => {
        const id = img.id;
        if (id) {
          const match = id.match(/am-slide_item-(\d+)/);
          if (match && match[1]) {
            highestId = Math.max(highestId, parseInt(match[1], 10));
          }
        }
      });

      allSlides.forEach((img) => {
        if (!img.id) {
          highestId += 1;
          img.id = `am-slide_item-${highestId}`;
        }
      });
    }

    // Assign data-slide-index attributes
    function assignSlideIndexes() {
      const allSlides = document.querySelectorAll(
        ".am-main_slider-img .am-slide_item"
      );
      const allTexts = document.querySelectorAll(".am-main_slider-text");

      allSlides.forEach((slide, index) => {
        if (!slide.hasAttribute("data-slide-index")) {
          slide.setAttribute("data-slide-index", index);
        }
      });

      allTexts.forEach((text, index) => {
        if (!text.hasAttribute("data-slide-index")) {
          text.setAttribute("data-slide-index", index);
        }
      });
    }

    // Hide slides with data-slide-none="true"
    function hideExcludedSlides() {
      const excludedSlides = document.querySelectorAll(
        '.am-slide_item[data-slide-none="true"], .am-main_slider-text[data-slide-none="true"]'
      );
      excludedSlides.forEach((element) => {
        element.style.display = "none";
      });
    }

    // Center active item on mobile
    function centerActiveItem() {
      if (window.innerWidth <= 860) {
        const activeText = document.querySelector(".am-main_slider-text.active");
        const container = document.querySelector(".am-main_slider-content");
        
        if (activeText && container) {
          const containerWidth = container.offsetWidth;
          const itemLeft = activeText.offsetLeft;
          const itemWidth = activeText.offsetWidth;
          
          // Calculate scroll position to center the item
          const scrollPosition = itemLeft - (containerWidth / 2) + (itemWidth / 2);
          
          container.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
        }
      }
    }

    assignSlideIDs();
    assignSlideIndexes();
    hideExcludedSlides();

    // Get sorted slides, excluding those with data-slide-none="true"
    function getSortedSlides() {
      const allSlides = Array.from(
        document.querySelectorAll(".am-main_slider-img .am-slide_item")
      );
      return allSlides
        .filter((slide) => slide.getAttribute("data-slide-none") !== "true")
        .sort((a, b) => {
          const indexA = parseInt(
            a.getAttribute("data-slide-index") || "9999",
            10
          );
          const indexB = parseInt(
            b.getAttribute("data-slide-index") || "9999",
            10
          );
          return indexA - indexB;
        });
    }

    // Set initial active slide
    const sortedSlides = getSortedSlides();
    if (sortedSlides.length > 0) {
      sortedSlides[0].classList.add("active");
      const firstIndex = parseInt(
        sortedSlides[0].getAttribute("data-slide-index") || "0",
        10
      );
      const firstText = Array.from(texts).find(
        (txt) =>
          parseInt(txt.getAttribute("data-slide-index") || "9999", 10) ===
          firstIndex
      );
      if (firstText) firstText.classList.add("active");
    }

    // Reset progress bars instantly
    function resetBarsInstantly(bars) {
      bars.forEach((bar) => {
        bar.style.transition = "none";
        bar.style.width = "0";
      });
      void document.body.offsetWidth;
    }

    // Start progress bar for active slide
    function startProgressBar() {
      const activeText = document.querySelector(".am-main_slider-text.active");
      if (!activeText) return;
      const activeBar = activeText.querySelector(".progress_bar-slider .blue");
      if (!activeBar) return;

      resetBarsInstantly(progressBars);

      progressBars.forEach((bar) => {
        bar.style.transition = bar === activeBar ? "width 5s linear" : "none";
        bar.style.width = bar === activeBar ? "100%" : "0";
      });

      clearTimeout(slideInterval);
      slideInterval = setTimeout(() => {
        nextSlide();
      }, 5000);
    }

    // Show a specific slide
    function showSlide(slideIndex) {
      if (isTransitioning) return;
      isTransitioning = true;
      clearTimeout(slideInterval);

      images.forEach((img) => {
        const imgIndex = parseInt(
          img.getAttribute("data-slide-index") || "9999",
          10
        );
        const isExcluded = img.getAttribute("data-slide-none") === "true";
        img.classList.toggle("active", imgIndex === slideIndex && !isExcluded);
        if (isExcluded) {
          img.style.display = "none";
        }
      });
      texts.forEach((txt) => {
        const txtIndex = parseInt(
          txt.getAttribute("data-slide-index") || "9999",
          10
        );
        const isExcluded = txt.getAttribute("data-slide-none") === "true";
        txt.classList.toggle("active", txtIndex === slideIndex && !isExcluded);
        if (isExcluded) {
          txt.style.display = "none";
        }
      });

      startProgressBar();
      currentSlide = slideIndex;

      // Center the active item on mobile
      setTimeout(() => {
        centerActiveItem();
      }, 50);

      setTimeout(() => {
        isTransitioning = false;
      }, 300);
    }

    // Move to the next slide
    function nextSlide() {
      const sortedIndexes = getSortedSlides().map((slide) =>
        parseInt(slide.getAttribute("data-slide-index") || "9999", 10)
      );
      const currentIndex = sortedIndexes.indexOf(currentSlide);
      const newIndex = sortedIndexes[(currentIndex + 1) % sortedIndexes.length];
      showSlide(newIndex);
    }

    // Move to the previous slide
    function prevSlide() {
      const sortedIndexes = getSortedSlides().map((slide) =>
        parseInt(slide.getAttribute("data-slide-index") || "9999", 10)
      );
      const currentIndex = sortedIndexes.indexOf(currentSlide);
      const newIndex =
        sortedIndexes[
          (currentIndex - 1 + sortedIndexes.length) % sortedIndexes.length
        ];
      showSlide(newIndex);
    }

    // Create navigation buttons
    function createNavigationButtons() {
      const nextBtn = document.querySelector(".am_slide--next");
      const prevBtn = document.querySelector(".am_slide--previous");

      if (nextBtn) {
        nextBtn.addEventListener("click", nextSlide);
      }
      if (prevBtn) {
        prevBtn.addEventListener("click", prevSlide);
      }
    }

    // Initialize the slider
    function initializeSlider() {
      hideExcludedSlides();
      const firstSlideIndex =
        sortedSlides.length > 0
          ? parseInt(
              sortedSlides[0].getAttribute("data-slide-index") || "0",
              10
            )
          : 0;
      showSlide(firstSlideIndex);
      createNavigationButtons();
      
      // Center on initial load for mobile
      setTimeout(() => {
        centerActiveItem();
      }, 100);
    }

    initializeSlider();

    // Add click event listeners to text elements
    texts.forEach((text) => {
      text.addEventListener("click", () => {
        const slideIndex = parseInt(
          text.getAttribute("data-slide-index") || "0",
          10
        );
        // Only show slide if it is not excluded
        if (
          getSortedSlides().some(
            (slide) =>
              parseInt(slide.getAttribute("data-slide-index"), 10) ===
              slideIndex
          )
        ) {
          showSlide(slideIndex);
        }
      });
    });

    // Re-center on window resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        centerActiveItem();
      }, 250);
    });
  }
  sliderLogic();

  //----------------------------
  // Function to handle video
  // playback on scroll on if it's in view
  //----------------------

  function videoInViewPlayback() {
    const videos = document.querySelectorAll(".video-is__inView");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (!video.dataset.hasPlayed && entry.isIntersecting) {
            video.play();

            video.addEventListener(
              "ended",
              () => {
                video.dataset.hasPlayed = "true";
                video.currentTime = video.duration;
              },
              { once: true }
            );
          }

          if (video.dataset.hasPlayed && !entry.isIntersecting) {
            video.pause();
            video.currentTime = video.duration;
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    videos.forEach((video) => {
      video.loop = false;
      observer.observe(video);
    });
  }
  videoInViewPlayback();

  //----------------------------------------
  // Function to change image
  // on scroll using canvas
  //----------------------------

  function changeImageOnScroll() {
    const canvas = document.getElementById("animation-canvas");
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const imagePath = canvas.dataset.imagePath;
    const totalImages = parseInt(canvas.dataset.totalImages, 10);
    const imageExtension = canvas.dataset.imageExtension || ".webp";
    const prefixLength = parseInt(canvas.dataset.imagePrefixLength || "3", 10);
    const triggerSelector =
      canvas.dataset.canvasTrigger || ".sticky__elements--section4";

    const images = [];
    let loadedImages = 0;
    let lastFrame = -1;

    const imageAspectRatio = 1920 / 1080;

    // Retina display fix
    const dpr = window.devicePixelRatio || 1;
    const displayWidth = window.innerWidth;
    const displayHeight = window.innerHeight;

    canvas.width = displayWidth * dpr;
    canvas.height = displayHeight * dpr;

    canvas.style.width = displayWidth + "px";
    canvas.style.height = displayHeight + "px";

    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.scale(dpr, dpr);
    ctx.imageSmoothingEnabled = true;

    let imageWidth = displayWidth;
    let imageHeight = displayWidth / imageAspectRatio;

    if (imageHeight > displayHeight) {
      imageHeight = displayHeight;
      imageWidth = displayHeight * imageAspectRatio;
    }

    const offsetX = Math.floor((displayWidth - imageWidth) / 2);
    const offsetY = Math.floor((displayHeight - imageHeight) / 2);

    let scrollProgress = 0;
    let currentFrameFloat = 0;

    function renderLoop() {
      const targetFrame = scrollProgress * (totalImages - 1);
      currentFrameFloat += (targetFrame - currentFrameFloat) * 0.1;
      const frame = Math.round(currentFrameFloat);

      if (frame !== lastFrame && images[frame]) {
        lastFrame = frame;
        ctx.clearRect(0, 0, displayWidth, displayHeight);
        ctx.drawImage(images[frame], offsetX, offsetY, imageWidth, imageHeight);
      }
      requestAnimationFrame(renderLoop);
    }

    function startAnimation() {
      ScrollTrigger.create({
        trigger: triggerSelector,
        start: "top top",
        end: "+=" + window.innerHeight * 5,
        scrub: true,
        pin: true,
        onUpdate: (self) => {
          scrollProgress = self.progress;
        },
      });
      renderLoop();
    }

    // Load images
    for (let i = 0; i < totalImages; i++) {
      const img = new Image();
      const paddedIndex = String(i).padStart(prefixLength, "0");
      img.src = `${imagePath}${paddedIndex}${imageExtension}`;

      img.onload = () => {
        loadedImages++;
        if (loadedImages === 1) {
          ctx.clearRect(0, 0, displayWidth, displayHeight);
          ctx.drawImage(img, offsetX, offsetY, imageWidth, imageHeight);
        }
        if (loadedImages === totalImages) {
          startAnimation();
        }
      };

      img.onerror = () => {
        console.error(`Failed to load image: ${img.src}`);
      };

      images.push(img);
    }
  }

  if (window.innerWidth > 820) {
    changeImageOnScroll();
  }

  //----------------------------------------
  // Function to Replace Text Across Sites
  //----------------------------

  function replaceTextAcrossSites() {
    if (".right__top") {
      return;
    }

    const replacements = [
      { pattern: /Game App/gi, replacement: "GAME APP" },
      { pattern: /Game/gi, replacement: "GAME" },
    ];

    function replaceText(node) {
      if (
        node.nodeType === Node.ELEMENT_NODE &&
        (node.tagName === "STYLE" || node.tagName === "SCRIPT")
      ) {
        return;
      }

      if (node.nodeType === Node.TEXT_NODE) {
        let text = node.textContent;
        replacements.forEach(({ pattern, replacement }) => {
          text = text.replace(pattern, replacement);
        });
        node.textContent = text;
      } else {
        node.childNodes.forEach(replaceText);
      }
    }

    document.body.childNodes.forEach(replaceText);
    }
  replaceTextAcrossSites();

  function changeLinkTextColor(selector, textColor) {
    const headerItem = document.querySelector(selector);

    if (headerItem) {
      const link = headerItem.querySelector('a[href="/pages/offer"]');

      if (link) {
        link.style.color = textColor;
      }
    }
  }

  const textColor = "#D80027";
  changeLinkTextColor(".header-item.header-item--split-right", textColor);
  changeLinkTextColor(".mobile-main-menu", textColor);

  function replaceText2(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const updatedText = node.nodeValue.replace(
        /TRAVIS MATHEW/g,
        "<span>TRAVISMATHEW</span>"
      );
      if (updatedText !== node.nodeValue) {
        const span = document.createElement("span");
        span.innerHTML = updatedText;
        node.parentNode.replaceChild(span, node);
      }
    } else {
      node.childNodes.forEach(replaceText2);
    }
  }

  replaceText2(document.body);

  function replaceText(node, replacements) {
    if (node.nodeType === Node.TEXT_NODE) {
      let updatedText = node.nodeValue;

      // Loop through all replacements and apply them
      replacements.forEach(({ pattern, replacement }) => {
        updatedText = updatedText.replace(pattern, replacement);
      });

      if (updatedText !== node.nodeValue) {
        node.nodeValue = updatedText;
      }
    } else if (
      node.nodeType === Node.ELEMENT_NODE &&
      !["SCRIPT", "STYLE", "NOSCRIPT"].includes(node.tagName)
    ) {
      node.childNodes.forEach((childNode) =>
        replaceText(childNode, replacements)
      );
    }
  }

  const textReplacements = [
    {
      pattern: /love it or your money back \| 60 day hassle-free returns/gi,
      replacement: "Love it or your money back | 100 day hassle-free returns",
    },
    {
      pattern: /60 day hassle-free returns/gi,
      replacement: "100 day hassle-free returns",
    },
    { pattern: /60 day returns/gi, replacement: "100 day returns" },
    { pattern: /60 days/gi, replacement: "100 DAYS" },
  ];

  replaceText(document.body, textReplacements);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) =>
        replaceText(node, textReplacements)
      );
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  function replaceTextTwo(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      node.nodeValue = node.nodeValue.replace(/SELECT Color:/g, "COLOR:");
    } else {
      node.childNodes.forEach(replaceTextTwo);
    }
  }
  replaceTextTwo(document.body);

  const spanElement = document.querySelector(
    ".ctm_success_message .cart_buttons span"
  );

  if (spanElement) {
    spanElement.classList.add("offer-msg");
  }

  function toggleOffer() {
    const offerMsg = document.querySelector(".offer-msg");
    if (offerMsg) {
      offerMsg.classList.toggle("show");
    }
  }

  const offerBtn = document.querySelector(".cart_buttons");
  if (offerBtn) {
    offerBtn.addEventListener("click", toggleOffer);
  }

  document.addEventListener("click", function (event) {
    const offerMsg = document.querySelector(".offer-msg");
    const offerBtn = document.querySelector(".cart_buttons");
    if (
      offerMsg &&
      offerBtn &&
      !offerMsg.contains(event.target) &&
      !offerBtn.contains(event.target)
    ) {
      offerMsg.classList.remove("show");
    }
  });

  const button = document.getElementById("myButton");
  if (button) {
    button.addEventListener("click", function () {
      document
        .querySelector(".additional-checkout-buttons")
        .classList.toggle("open-descrption");
    });
  } else {
    console.warn("Element with ID 'myButton' not found.");
  }

  $(".same-page-scroll").click(function () {
    window.location.reload();
  });

  //----------------------------
  // Function to handle
  // opening and closing modals
  //---------------

  function openingPopUp() {
    var learnMoreLinks = document.querySelectorAll(
      ".learn-more-link, .has__popup"
    );
    var closeBtns = document.querySelectorAll(".close, [data-close-popup]");

    learnMoreLinks.forEach(function (learnMoreLink) {
      learnMoreLink.onclick = function (event) {
        event.preventDefault();

        var modalId = learnMoreLink.getAttribute("data-target");
        var modal = document.getElementById(modalId);

        if (modal) {
          modal.style.display = "block";
        }
      };
    });

    closeBtns.forEach(function (closeBtn) {
      closeBtn.onclick = function () {
        var modal = closeBtn.closest(".modal");
        if (modal) {
          modal.style.display = "none";
        }
      };
    });

    window.onclick = function (event) {
      document.querySelectorAll(".modal").forEach(function (modal) {
        if (event.target === modal) {
          modal.style.display = "none";
        }
      });
    };
  }
  openingPopUp();

  //--------------------------------
  // Function to handle
  // sticky header and sticky areas
  //----------------

  function stickyHeaderFromTop() {
    let lastScrollTop = 0;
    const scrollDownThreshold = 20;
    const scrollUpThreshold = 0;
    const header = document.querySelector(".site-header");
    const stickyAreas = document.querySelectorAll(
      ".tow_content--sticky-area, .playmaker_header-custom"
    );

    function updateStickyAreaPositions() {
      if (header) {
        const headerHeight = header.offsetHeight;

        stickyAreas.forEach((stickyArea) => {
          stickyArea.style.top = `${headerHeight}px`;
        });
      }
    }

    window.addEventListener("resize", updateStickyAreaPositions);

    window.addEventListener("scroll", function () {
      let currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > scrollDownThreshold) {
        header.classList.add("fixed");

        if (
          currentScroll > lastScrollTop &&
          currentScroll > scrollDownThreshold + 10
        ) {
          header.classList.add("hidden");

          stickyAreas.forEach((stickyArea) => {
            stickyArea.style.top = "0";
          });
        } else if (lastScrollTop - currentScroll > scrollUpThreshold) {
          header.classList.remove("hidden");
          updateStickyAreaPositions();
        }
      } else {
        header.classList.remove("fixed");
        header.classList.remove("hidden");
        updateStickyAreaPositions();
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    });

    updateStickyAreaPositions();
  }
  stickyHeaderFromTop();

  //--------------------------------
  // Function to handle
  // mute button functionality
  //------------------

  function HandlingTheMuteBtn() {
    const video = document.getElementById("myVideo");
    const volumeToggle = document.getElementById("volumeToggle");
    const muteIcon = document.querySelector(".mute-icon");
    const unmuteIcon = document.querySelector(".unmute-icon");

    // Check if all required elements exist
    if (!video || !volumeToggle || !muteIcon || !unmuteIcon) {
      console.warn(
        "One or more elements (video, volumeToggle, muteIcon, unmuteIcon) not found."
      );
      return; // Exit if any element is missing
    }

    // Ensure the video is muted initially
    video.muted = true;

    // Toggle button functionality
    volumeToggle.addEventListener("click", function () {
      video.muted = !video.muted;

      if (video.muted) {
        muteIcon.style.display = "inline";
        unmuteIcon.style.display = "none";
      } else {
        muteIcon.style.display = "none";
        unmuteIcon.style.display = "inline";
      }
    });
  }

  HandlingTheMuteBtn();

  //------------------------------
  // Function to control
  // video playback and mute state
  //-----------------

  function videoControling() {
    const videos = document.querySelectorAll(".myVideo");
    const controlIcons = document.querySelectorAll(".videoControlIcon");

    videos.forEach((video, index) => {
      const icon = controlIcons[index];

      // Play video on icon click
      icon.addEventListener("click", function () {
        if (video.paused) {
          video.play();
          video.muted = false;
          icon.style.display = "none";
        }
      });

      // Pause video on click
      video.addEventListener("click", function () {
        if (!video.paused) {
          video.pause();
          video.muted = true;
          icon.style.display = "block";
        }
      });

      // Handle video end
      video.addEventListener("ended", function () {
        video.currentTime = 0;
        video.muted = true;
        icon.style.display = "block";
      });
    });
  }

  videoControling();

  //--------------------------------
  // Function to handle FAQ blocks
  // and search functionality
  // For CS TEAM FAQ PAGE
  //-----------------

  function appFaqBlocksHandling() {
    const faqBlocks = document.querySelectorAll('[id*="app_faq_blocks"]');
    const searchInput = document.querySelector("#faqSearch");
    const noResults = document.querySelector(".faq-no-results");
    if (!searchInput || !faqBlocks || !noResults) return;

    // Store original content to restore when clearing search
    faqBlocks.forEach((block) => {
      const productId = block.dataset.productId;
      const overlay = document.querySelector(
        `.faq_overlay[data-product-id="${productId}"]`
      );
      const title = block.querySelector(".faq_block--left h3");
      const faqItems = overlay ? overlay.querySelectorAll(".faq-item") : [];

      if (title) {
        title.dataset.original = title.innerHTML;
      }

      faqItems.forEach((item) => {
        const question = item.querySelector(".faq-question");
        const answer = item.querySelector(".faq-answer");
        question.dataset.original = question.innerHTML;
        answer.dataset.original = answer.innerHTML;
      });
    });

    // Toggle FAQ items (unchanged, but query all once)
    const faqItemsAll = document.querySelectorAll(".faq-item");
    faqItemsAll.forEach((item) => {
      const question = item.querySelector(".faq-question");
      question.addEventListener("click", () => {
        const answer = item.querySelector(".faq-answer");
        const isOpen = answer.style.display === "block";

        if (isOpen) {
          answer.style.display = "none";
          item.classList.remove("active");
          question.querySelector(".toggle-icon").textContent = "+";
        } else {
          answer.style.display = "block";
          item.classList.add("active");
          question.querySelector(".toggle-icon").textContent = "−";
        }
      });
    });

    // Search and highlight functionality, now filtering at product/block level

    searchInput.addEventListener("input", function () {
      const searchTerm = this.value.trim().toLowerCase();
      let visibleBlocksCount = 0;

      faqBlocks.forEach((block) => {
        const productId = block.dataset.productId;
        const overlay = document.querySelector(
          `.faq_overlay[data-product-id="${productId}"]`
        );
        const title = block.querySelector(".faq_block--left h3");
        const faqItems = overlay ? overlay.querySelectorAll(".faq-item") : [];
        let blockMatches = false;

        // Restore original content for title and items
        if (title) {
          title.innerHTML = title.dataset.original;
        }
        faqItems.forEach((item) => {
          const question = item.querySelector(".faq-question");
          const answer = item.querySelector(".faq-answer");
          question.innerHTML = question.dataset.original;
          answer.innerHTML = answer.dataset.original;
          // Close item by default during search
          answer.style.display = "none";
          item.classList.remove("active");
          question.querySelector(".toggle-icon").textContent = "+";
        });

        if (searchTerm) {
          const titleText = title ? title.textContent.toLowerCase() : "";

          // Check title for match
          if (titleText.includes(searchTerm)) {
            blockMatches = true;
            // Highlight in title
            const regex = new RegExp(`(${searchTerm})`, "gi");
            title.innerHTML = title.textContent.replace(
              regex,
              "<mark>$1</mark>"
            );
          }

          // Check each FAQ item for matches
          faqItems.forEach((item) => {
            const question = item.querySelector(".faq-question");
            const answer = item.querySelector(".faq-answer");
            const questionText = question.textContent.toLowerCase();
            const answerText = answer.textContent.toLowerCase();
            let itemMatches = false;

            if (questionText.includes(searchTerm)) {
              blockMatches = true;
              itemMatches = true;
              const regex = new RegExp(`(${searchTerm})`, "gi");
              const questionContent = question.textContent.replace(
                regex,
                "<mark>$1</mark>"
              );
              question.innerHTML =
                questionContent +
                question.querySelector(".toggle-icon").outerHTML;
            }

            if (answerText.includes(searchTerm)) {
              blockMatches = true;
              itemMatches = true;
              const regex = new RegExp(`(${searchTerm})`, "gi");
              answer.innerHTML = answer.innerHTML.replace(
                regex,
                "<mark>$1</mark>"
              );
            }

            // Optionally auto-open matching items (when overlay is opened later)
            if (itemMatches) {
              // Note: Since overlay is hidden, we don't open here; user will click block to see overlay
            }

            // Always show all items within a matching block's overlay (no hiding individual items)
            item.style.display = "inline-block";
          });
        } else {
          // No search term: show all blocks and items, closed
          blockMatches = true;
          faqItems.forEach((item) => {
            item.style.display = "inline-block";
          });
        }

        // Show/hide the entire block based on matches
        block.style.display = blockMatches ? "inline-block" : "none";
        // Also hide/show the associated overlay (though it's probably already hidden via CSS)
        if (overlay) {
          overlay.style.display = blockMatches ? "inline-block" : "none";
        }
        if (blockMatches) {
          visibleBlocksCount++;
        }
      });

      // Show/hide no results message
      noResults.style.display =
        visibleBlocksCount === 0 && searchTerm ? "block" : "none";
    });
  }
  appFaqBlocksHandling();

  function openingFaqBackFace() {
    const faqBlocks = document.querySelectorAll(".faq__block");
    const faqOverlays = document.querySelectorAll(".faq_overlay");

    function openOverlay(overlay) {
      document.body.classList.add("no-scroll_faq");
      overlay.style.display = "block";
      gsap.to(overlay, {
        y: 0,
        duration: 0.6,
        ease: "power2.out",
      });
    }

    function closeOverlay(overlay) {
      gsap.to(overlay, {
        y: "100vh",
        duration: 0.6,
        ease: "power2.in",
        onComplete: () => {
          overlay.style.display = "none";
          document.body.classList.remove("no-scroll_faq");
        },
      });
    }

    faqBlocks.forEach((block) => {
      block.addEventListener("click", () => {
        const productId = block.getAttribute("data-product-id");
        const targetOverlay = document.querySelector(
          `.faq_overlay[data-product-id="${productId}"]`
        );
        if (targetOverlay) {
          openOverlay(targetOverlay);
        }
      });
    });

    faqOverlays.forEach((overlay) => {
      const closeIcon = overlay.querySelector(".close-icon");
      const overlayContent = overlay.querySelector(".overlay__content");

      closeIcon.addEventListener("click", () => {
        closeOverlay(overlay);
      });

      overlay.addEventListener("click", (e) => {
        if (!overlayContent.contains(e.target)) {
          closeOverlay(overlay);
        }
      });
    });
  }
  openingFaqBackFace();

  /*-------------------------------
    Parallex
  -----------------*/

  function parallexHero() {
    const videoRefs = document.querySelectorAll(".has_parallex");

    if (!videoRefs.length) {
      console.warn("No elements found: .has_parallex");
      return;
    }

    const throttle = (func, limit) => {
      let inThrottle;
      return (...args) => {
        if (!inThrottle) {
          func.apply(this, args);
          inThrottle = true;
          setTimeout(() => (inThrottle = false), limit);
        }
      };
    };

    const handleScroll = throttle(() => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;

      videoRefs.forEach((videoRef, index) => {
        const rect = videoRef.getBoundingClientRect();
        const elementTop = rect.top + scrollPosition;
        const elementBottom = elementTop + rect.height;

        const startScroll = elementTop - windowHeight * 0.5;
        const endScroll = elementBottom - windowHeight * 0.1;

        let progress =
          (scrollPosition - startScroll) / (endScroll - startScroll);
        progress = Math.max(0, Math.min(1, progress));

        const translateY = progress * 100 * (index + 1);
        videoRef.style.transform = `matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, ${translateY}, 0, 1)`;
      });
    }, 1);

    const handleResize = throttle(() => {
      handleScroll();
    }, 100);

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }

  parallexHero();

  /*----------------------------
    VIDEO PREVIEW LOGIC  
  ----------------*/

  function handleVideoPreview() {
    const videoPreviews = document.querySelectorAll(".video-preview");
    const startTime = 0;
    const endTime = 5;

    // Store all video instances globally to manage playback
    const videoInstances = [];

    videoPreviews.forEach((preview, index) => {
      // Select all required elements
      const previewVideo = preview.querySelector(".preview-video");
      const playButton = preview.querySelector(".play-button");
      const loader = document.getElementById(`loader-${index + 1}`);

      // Validate required elements
      if (!previewVideo || !playButton || !loader) {
        console.error(
          `Missing required elements for video block ${index + 1}`,
          {
            previewVideo: !!previewVideo,
            playButton: !!playButton,
            loader: !!loader,
          }
        );
        return;
      }

      // Get popup elements
      const videoPopup = document.getElementById(`dialog-video__${index + 1}`);
      const popupContent = document.getElementById(
        `dialog-content__${index + 1}`
      );
      const fullVideo = document.getElementById(
        `dialog-full__video-${index + 1}`
      );
      const closeButton = document.getElementById(
        `dialog-close__btn-${index + 1}`
      );

      // Determine mode with proper attribute checking
      const hasPopupElements =
        videoPopup && popupContent && fullVideo && closeButton;
      const playInPlaceAttr = preview.dataset.playInPlace;

      // Logic:
      // - If data-play-in-place="true" -> play in place
      // - If data-play-in-place="false" -> force popup mode (even without popup elements)
      // - If no attribute and no popup elements -> play in place (fallback)
      // - If no attribute and has popup elements -> popup mode (default)
      let playInPlace;
      if (playInPlaceAttr === "true") {
        playInPlace = true;
      } else if (playInPlaceAttr === "false") {
        playInPlace = false;
        // Validate popup elements are available when forced to popup mode
        if (!hasPopupElements) {
          console.error(
            `Video block ${
              index + 1
            } has data-play-in-place="false" but missing popup elements`
          );
          return;
        }
      } else {
        // No attribute: use popup if elements exist, otherwise play in place
        playInPlace = !hasPopupElements;
      }

      // Get video URL and determine if it's an iframe (Vimeo/YouTube)
      const videoUrl = preview.dataset.videoUrl;
      const isIframe =
        videoUrl.includes("vimeo.com") || videoUrl.includes("youtube.com");

      // Set preview and full video sources
      if (isIframe) {
        previewVideo.src = videoUrl;
        if (!playInPlace && fullVideo) {
          fullVideo.src = videoUrl.replace("autoplay=1", "");
        }
      } else {
        previewVideo.src = videoUrl;
        if (!playInPlace && fullVideo) {
          fullVideo.src = videoUrl;
        }
      }

      // Function to hide loader
      const hideLoader = () => {
        loader.style.display = "none";
        preview.classList.add("dialog-video__loading");
      };

      // Track if we're in preview mode or full playback mode
      let isPreviewMode = true;
      let vimeoPlayer = null; // Store Vimeo player instance
      let isPlayingFull = false; // Track if this video is playing full

      // Store video instance info
      const videoInstance = {
        index: index + 1,
        previewVideo,
        playButton,
        isIframe,
        vimeoPlayer: null,
        playInPlace,
        stopFullPlayback: () => {
          if (isPlayingFull) {
            if (isIframe && videoUrl.includes("vimeo.com") && vimeoPlayer) {
              vimeoPlayer.pause();
              vimeoPlayer.setCurrentTime(startTime);
              vimeoPlayer.setLoop(true);
            } else {
              previewVideo.pause();
              previewVideo.currentTime = startTime;
              previewVideo.loop = true;
              previewVideo.muted = true;
            }
            playButton.style.opacity = "1";
            playButton.style.pointerEvents = "auto";
            isPreviewMode = true;
            isPlayingFull = false;

            // Resume preview playback
            if (isIframe && videoUrl.includes("vimeo.com") && vimeoPlayer) {
              vimeoPlayer.play();
            } else {
              previewVideo.play();
            }
          }
        },
      };
      videoInstances.push(videoInstance);

      // Handle preview video/iframe playback
      if (isIframe && videoUrl.includes("vimeo.com")) {
        vimeoPlayer = new Vimeo.Player(previewVideo);
        videoInstance.vimeoPlayer = vimeoPlayer;

        vimeoPlayer.on("loaded", () => {
          hideLoader();
          vimeoPlayer.setCurrentTime(startTime).then(() => {
            vimeoPlayer.play().catch((error) => {
              console.log(
                `Autoplay prevented for Vimeo video ${index + 1}:`,
                error
              );
              document.addEventListener(
                "click",
                () => {
                  vimeoPlayer.play();
                },
                { once: true }
              );
            });
          });
        });
        vimeoPlayer.on("timeupdate", (data) => {
          // Only loop preview if in preview mode
          if (isPreviewMode && data.seconds >= endTime) {
            vimeoPlayer.setCurrentTime(startTime);
          }
        });
        vimeoPlayer.on("error", () => {
          console.error(`Error loading Vimeo video ${index + 1}`);
          hideLoader();
        });
      } else {
        previewVideo.addEventListener("loadedmetadata", () => {
          hideLoader();
          previewVideo.currentTime = startTime;
          previewVideo.play().catch((error) => {
            console.log(`Autoplay prevented for video ${index + 1}:`, error);
            document.addEventListener(
              "click",
              () => {
                previewVideo.play();
              },
              { once: true }
            );
          });
        });
        previewVideo.addEventListener("timeupdate", () => {
          // Only loop preview if in preview mode
          if (isPreviewMode && previewVideo.currentTime >= endTime) {
            previewVideo.currentTime = startTime;
          }
        });
        previewVideo.addEventListener("error", () => {
          console.error(`Error loading video ${index + 1}`);
          hideLoader();
        });
      }

      // Add click handler to video for play-in-place mode to stop playback
      if (playInPlace) {
        const handleVideoClick = (e) => {
          // Only handle click if video is playing in full mode and not clicking the play button
          if (isPlayingFull && !playButton.contains(e.target)) {
            e.stopPropagation();
            // Stop full playback and return to preview
            if (isIframe && videoUrl.includes("vimeo.com") && vimeoPlayer) {
              vimeoPlayer.pause();
              vimeoPlayer.setCurrentTime(startTime);
              vimeoPlayer.setLoop(true);
              vimeoPlayer.play();
            } else {
              previewVideo.pause();
              previewVideo.currentTime = startTime;
              previewVideo.loop = true;
              previewVideo.muted = true;
              previewVideo.play();
            }
            playButton.style.opacity = "1";
            playButton.style.pointerEvents = "auto";
            isPreviewMode = true;
            isPlayingFull = false;
          }
        };

        preview.addEventListener("click", handleVideoClick);
      }

      // Handle play button click
      playButton.addEventListener("click", (e) => {
        e.stopPropagation(); // Prevent video click handler from firing

        if (playInPlace) {
          // Stop all other videos that are playing in full
          videoInstances.forEach((instance) => {
            if (instance.index !== index + 1 && instance.playInPlace) {
              instance.stopFullPlayback();
            }
          });

          // Switch to full playback mode
          isPreviewMode = false;
          isPlayingFull = true;

          // Hide play button immediately
          playButton.style.opacity = "0";
          playButton.style.pointerEvents = "none";

          // Play in place: play full video in the same container
          if (isIframe && videoUrl.includes("vimeo.com") && vimeoPlayer) {
            vimeoPlayer
              .setCurrentTime(0)
              .then(() => {
                vimeoPlayer.setLoop(false);
                vimeoPlayer.play();
              })
              .catch((error) => {
                console.error(
                  `Error playing full Vimeo video ${index + 1}:`,
                  error
                );
                // Show play button again if there's an error
                playButton.style.opacity = "1";
                playButton.style.pointerEvents = "auto";
                isPreviewMode = true;
                isPlayingFull = false;
              });

            // Show play button again when video ends
            vimeoPlayer.on("ended", () => {
              playButton.style.opacity = "1";
              playButton.style.pointerEvents = "auto";
              isPreviewMode = true;
              isPlayingFull = false;
              vimeoPlayer.setCurrentTime(startTime);
              vimeoPlayer.setLoop(true);
              vimeoPlayer.play();
            });
          } else {
            // For HTML5 video
            previewVideo.currentTime = 0;
            previewVideo.loop = false;
            previewVideo.muted = false; // Unmute for full playback

            // Play the video
            const playPromise = previewVideo.play();

            if (playPromise !== undefined) {
              playPromise.catch((error) => {
                console.error(`Error playing full video ${index + 1}:`, error);
                // Show play button again if there's an error
                playButton.style.opacity = "1";
                playButton.style.pointerEvents = "auto";
                isPreviewMode = true;
                isPlayingFull = false;
                previewVideo.muted = true;
              });
            }

            // Show play button again when video ends
            const handleVideoEnd = () => {
              playButton.style.opacity = "1";
              playButton.style.pointerEvents = "auto";
              isPreviewMode = true;
              isPlayingFull = false;
              previewVideo.currentTime = startTime;
              previewVideo.loop = true;
              previewVideo.muted = true; // Mute again for preview
              previewVideo.play();
              previewVideo.removeEventListener("ended", handleVideoEnd);
            };
            previewVideo.addEventListener("ended", handleVideoEnd);
          }
        } else {
          // Stop all other videos that are playing in full (play-in-place ones)
          videoInstances.forEach((instance) => {
            if (instance.playInPlace) {
              instance.stopFullPlayback();
            }
          });

          // Original popup behavior
          if (isIframe && videoUrl.includes("vimeo.com")) {
            const fullPlayer = new Vimeo.Player(fullVideo);
            if (previewVideo.tagName === "IFRAME") {
              if (vimeoPlayer) {
                vimeoPlayer.pause();
              }
            } else {
              previewVideo.pause();
            }
            document.body.classList.add("dialog-box__open");
            gsap.to(videoPopup, {
              opacity: 1,
              duration: 0.2,
              ease: "power2.out",
              onStart: () => {
                videoPopup.style.display = "flex";
                videoPopup.style.pointerEvents = "auto";
              },
            });
            gsap.to(popupContent, {
              opacity: 1,
              duration: 0.5,
              ease: "power2.out",
              delay: 0.2,
              onComplete: () => {
                fullPlayer.play();
              },
            });
          } else {
            previewVideo.pause();
            document.body.classList.add("dialog-box__open");
            gsap.to(videoPopup, {
              opacity: 1,
              duration: 0.2,
              ease: "power2.out",
              onStart: () => {
                videoPopup.style.display = "flex";
                videoPopup.style.pointerEvents = "auto";
              },
            });
            gsap.to(popupContent, {
              opacity: 1,
              duration: 0.5,
              ease: "power2.out",
              delay: 0.2,
              onComplete: () => {
                fullVideo.play();
              },
            });
          }
        }
      });

      // Close popup functionality (only for popup mode)
      if (!playInPlace && closeButton) {
        closeButton.addEventListener("click", () => {
          gsap.to(popupContent, {
            opacity: 0,
            duration: 0.5,
            ease: "power2.in",
            onStart: () => {
              if (isIframe && videoUrl.includes("vimeo.com")) {
                const fullPlayer = new Vimeo.Player(fullVideo);
                fullPlayer.pause();
                if (fullVideo.dataset.videoBehavior === "restart") {
                  fullPlayer.setCurrentTime(0);
                }
                if (previewVideo.tagName === "IFRAME") {
                  if (vimeoPlayer) {
                    vimeoPlayer.play();
                  }
                } else {
                  previewVideo.play();
                }
              } else {
                fullVideo.pause();
                if (fullVideo.dataset.videoBehavior === "restart") {
                  fullVideo.currentTime = 0;
                }
                previewVideo.play();
              }
            },
          });
          gsap.to(videoPopup, {
            opacity: 0,
            duration: 0.2,
            ease: "power2.in",
            delay: 0.5,
            onComplete: () => {
              videoPopup.style.display = "none";
              videoPopup.style.pointerEvents = "none";
              document.body.classList.remove("dialog-box__open");
            },
          });
        });

        // Close popup on ESC key
        document.addEventListener("keydown", (e) => {
          if (e.key === "Escape" && videoPopup.style.display !== "none") {
            closeButton.click();
          }
        });
      }
    });
  }

  handleVideoPreview();

  /*----------------------------
    MOBILE DROPDOWN LOGIC  
  ----------------*/

  function initMobileDropdowns() {
    if (!window.matchMedia("(max-width: 860px)").matches) return;

    const cards = document.querySelectorAll(
      ".ringer-card[data-dropdown-card-open]"
    );

    cards.forEach((card) => {
      const dropdown = card.querySelector("[data-dropdown-card]");
      if (!dropdown) return;

      dropdown.style.height = "0px";

      const getHeight = () => {
        dropdown.style.height = "auto";
        const h = dropdown.scrollHeight + "px";
        dropdown.style.height = "0px";
        return h;
      };

      card.addEventListener("click", function (e) {
        const isOpen = card.classList.contains("is-open");

        document
          .querySelectorAll(".ringer-card.is-open")
          .forEach((openCard) => {
            if (openCard !== card) {
              openCard.classList.remove("is-open");
              const otherDrop = openCard.querySelector("[data-dropdown-card]");
              if (otherDrop) otherDrop.style.height = "0px";
            }
          });

        if (isOpen) {
          card.classList.remove("is-open");
          dropdown.style.height = "0px";
        } else {
          const target = getHeight();
          card.classList.add("is-open");
          dropdown.style.height = target;

          const onEnd = () => {
            dropdown.style.height = "0";
            dropdown.removeEventListener("transitionend", onEnd);
          };
          dropdown.addEventListener("transitionend", onEnd);
        }
      });
    });
  }

  initMobileDropdowns();
});

//-------------------------------
// Function to handle
// video scaling animation
//-----------------

function videoScalingAnimation() {
  const isPlayMakerPage =window.location.pathname === "/pages/play-maker-plus-landing-page";
  const mediaQueryBreakpoint = isPlayMakerPage ? 820 : 768;

  document
    .querySelectorAll(".video_scale_animation-main")
    .forEach((videoContainer, index) => {
      const videoId =
        videoContainer.querySelector("video").id || `myVideo-${index}`;
      const volumeToggleId =
        videoContainer.querySelector(".volume-btn").id ||
        `volumeToggle-${index}`;
      const video = document.getElementById(videoId);
      const loader = videoContainer.querySelector(".loader");

      // Add event listeners for video loading state
      if (video && loader) {
        video.addEventListener("waiting", () => {
          loader.style.display = "block"; // Show loader when buffering
        });
        video.addEventListener("playing", () => {
          loader.style.display = "none"; // Hide loader when playing
        });
        video.addEventListener("canplay", () => {
          loader.style.display = "none"; // Hide loader when video is ready to play
        });
      }

      gsap.timeline({
        scrollTrigger: {
          trigger: videoContainer,
          start: "top top",
          end: "bottom bottom",
          scrub: 0.2,
          markers: false,
          invalidateOnRefresh: true,
          onEnter: function () {
            if (video && !video.hasAttribute("autoplay")) {
              video.setAttribute("autoplay", "true");
            }
            video.play();
          },
        },
      });

      const isAnimationDisabled = videoContainer.dataset.isDisable === "true";

      if (window.innerWidth > mediaQueryBreakpoint && !isAnimationDisabled) {
        gsap
          .timeline({
            scrollTrigger: {
              trigger: videoContainer,
              start: "top top",
              end: "+=" + window.innerHeight * 2,
              scrub: 0.2,
              markers: false,
              pin: true,
            },
          })
          .from(
            videoContainer.querySelector(
              ".video_scale_animation .has_video_scale"
            ),
            {
              scale: 0.7,
              borderRadius: "20px",
            }
          )
          .to(
            videoContainer.querySelector(
              ".video_scale_animation .has_video_scale"
            ),
            {
              scale: 1,
              borderRadius: "0px",
            }
          );
      }
    });
}
videoScalingAnimation();

/*---------------------------
  Changing Image 
  Based On Varient
  --------------*/

function changeImageOnVarient() {
  /*--------------------------
    How To Use: Just goto the PDP and navigate to this line of code "{%- when 'tab' -%}",  
    in page you found two with this you have to   add a div with the class "tab_area". To the first one,
    Now this is gonna work as you wanted [class*="content-collapsibles-box-of-"].
    --------------*/

  /*------------------------------
    Product Configurations

    "defaultImageUrl" --  Default Image when user land on the page.
    "variantConfigs" --  prodive the variant id to change image on:
    "imageUrl" -- this is gonna hold the url for the different variant.
    "newTagSelector" --  if you have any label e.g "NEW" which needs to be displayed on for a specifce variant.
    "productImageSelector" --  this is for the tab selection which we're using to target image which is gonna be change on variant, Right now it's properly configured, By using css prifix "[class*="content-collapsibles-box-of-"].".
    
    ------------*/

  const productConfigs = {
    "/products/series-4-ultra-rangefinder": {
      defaultImageUrl:
        "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/Group_1000012418754.png?v=1745401143",
      variantConfigs: {
        44682629578949: {
          imageUrl:
            "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/Group_1000012411.png?v=1745401143",
          showNewTag: false,
        },
      },
      newTagSelector: "#new-tag",
      productImageSelector:
        '.tab_area .product-block.product-block--tab:nth-child(3) [class*="content-collapsibles-box-of-"] img',
    },

    "/products/ringer": {
      defaultImageUrl:
        "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/Frame_1000012491.png?v=1753344261",
      variantConfigs: {
        42373188485317: {
          imageUrl:
            "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/icons-ringer-pdp-inbox.png?v=1753340484",
          showNewTag: false,
        },
      },
      newTagSelector: "#new-tag",
      productImageSelector:
        '.tab_area .product-block.product-block--tab:nth-child(3) [class*="content-collapsibles-box-of-"] img',
    },

    "/products/player-gps-speaker": {
      defaultImageUrl:
        "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/Frame_1000012501.png?v=1758178054",
      variantConfigs: {
        42266534019269: {
          imageUrl:
            "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/Frame_1000012485.png?v=1758178054",
          showNewTag: false,
        },
      },
      newTagSelector: "#new-tag",
      productImageSelector:
        '.tab_area .product-block.product-block--tab:nth-child(3) [class*="content-collapsibles-box-of-"] img',
    },

    "/products/series-3-max-golf-rangefinder-with-slope": {
      defaultImageUrl:
        "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/icons-s3max-pdp-inbox.png?v=1752134770",
      variantConfigs: {
        43348096450757: {
          imageUrl:
            "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/Frame_1000012494.png?v=1753346816",
          showNewTag: false,
        },
        43368679080133: {
          imageUrl:
            "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/Frame_1000012494.png?v=1753346816",
          showNewTag: false,
        },
      },
      newTagSelector: "#new-tag",
      productImageSelector:
        '.tab_area .product-block.product-block--tab:nth-child(3) [class*="content-collapsibles-box-of-"] img',
    },

    "/products/rangefinder-series-2-pro": {
      defaultImageUrl:
        "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/icons-2pro-pdp-inbox.png?v=1752134771",
      variantConfigs: {
        41389169508549: {
          imageUrl:
            "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/Frame_1000012495.png?v=1753347401",
          showNewTag: false,
        },
      },
      newTagSelector: "#new-tag",
      productImageSelector:
        '.tab_area .product-block.product-block--tab:nth-child(3) [class*="content-collapsibles-box-of-"] img',
    },

    "/products/magnetic-golf-speaker": {
      defaultImageUrl:
        "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/icons-pgo-pdp-inbox.png?v=1752134770",
      variantConfigs: {
        42817543569605: {
          imageUrl:
            "https://cdn.shopify.com/s/files/1/0057/8958/1381/files/Frame_1000012496.png?v=1753350340",
          showNewTag: false,
        },
      },
      newTagSelector: "#new-tag",
      productImageSelector:
        '.tab_area .product-block.product-block--tab:nth-child(3) [class*="content-collapsibles-box-of-"] img',
    },
  };

  /*------------------------------
    Main Function For Image Change On Variant

    (DO NOT TOUCH THIS FUNCTION, THANK YOU..!)
    ---------------*/

  function setupVariantHandler(config) {
    const {
      defaultImageUrl,
      variantConfigs,
      newTagSelector,
      productImageSelector,
    } = config;

    const newTag = document.querySelector(newTagSelector);
    const productImage = document.querySelector(productImageSelector);

    const updateVariantContent = () => {
      const variantSelector = document.querySelector(
        'select[name="id"], input[name="id"]:checked'
      );
      const selectedVariantId = variantSelector ? variantSelector.value : null;

      const variantConfig = variantConfigs[selectedVariantId] || {};
      const { imageUrl = defaultImageUrl, showNewTag = false } = variantConfig;

      if (newTag) {
        newTag.style.display = showNewTag ? "flex" : "none";
      }
      if (productImage) {
        productImage.src = imageUrl;
      }
    };

    updateVariantContent();

    const variantInputs = document.querySelectorAll(
      'select[name="id"], input[name="id"]'
    );
    variantInputs.forEach((input) => {
      input.addEventListener("change", updateVariantContent);
    });

    document.addEventListener("variant:change", updateVariantContent, {
      passive: true,
    });
  }

  const currentPath = window.location.pathname;
  const config = productConfigs[currentPath];
  if (config) {
    setupVariantHandler(config);
  } else {
    // ONLY ENABLE THIS IF NEED FOR DEBUGING
    // console.warn("No configuration found for the current URL:", currentPath);
  }
}
changeImageOnVarient();
